import { AnalysisItem, LegendItem } from "helpers/models";
import { Content } from "pdfmake/interfaces";
import FATHOM_LAYER_ARRAY from "components/fathomAnalyze/id";
import getColor from "report/common/color";
import getLayer from "report/common/layer";
import getRect from "report/common/rect";
import getOther from "./other/other";
import getFathom from "./fathom/fathom";
import gap from "report/common/gap";
import getOutside from "report/common/outside";
import getMatchingTitle from "components/fathomAnalyze/util";

const get = (
  t: any,
  analysisItems: AnalysisItem[],
  legendItems: LegendItem[]
): Content[] => {
  const row = analysisItems.map((e) => {
    const legend = legendItems.find((i) => e.layerId === i.layerId);

    if (!legend || !legend.rules || !legend.rules.length) {
      return [];
    }

    const exclude = ["No Data", "Outside", "No Observation"];
    const rules = legend.rules.filter((e) => !exclude.includes(e.title));

    const index = rules.findIndex(
      (item) =>
        item.title === e.valueLabel ||
        item.title ===
          getMatchingTitle(e.valueLabel.replace("years", "").replace(" ", ""))
    );

    const colorArray = getColor(rules);

    const grey = ["Outside", "No Observation", "Waterbody"];
    const fillColor = e.valueLabel === "Waterbody" ? "#DCDBDC" : "#D3D3D3";

    return [
      gap(30),
      getLayer(t, e.layerId, 10, 1),
      gap(10),
      grey.includes(e.valueLabel)
        ? getOutside(fillColor, 555)
        : getRect(colorArray, index, 555),
      gap(10),
      FATHOM_LAYER_ARRAY.includes(e.layerId)
        ? getFathom(t, e, legend)
        : getOther(t, e)
    ];
  });

  return [...row];
};

export default get;
